import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  voucherRemoveButtonText: {
    id: 'checkout.cartPage.voucher.removeText',
    defaultMessage: 'remove',
    description: 'Placeholder text that is being displayed in remove button',
  },

  voucherRemoveButtonHelpText: {
    id: 'checkout.cartPage.voucher.removeHelpText',
    defaultMessage: 'help',
    description: 'Placeholder text that is being displayed in remove button',
  },
  voucherAppliedVoucherText: {
    id: 'checkout.cartPage.voucher.appliedVoucher',
    defaultMessage: '<b>Applied voucher: </b> {voucherCode}',
    description: 'Placeholder text that is being displayed in voucher list item',
  },
  voucherFreeDeliveryText: {
    id: 'checkout.cartPage.voucher.freeDeliveryVoucher',
    defaultMessage: '<b>Postage discount 100 %</b>',
    description: 'Placeholder text that is being displayed in voucher list item for free delivery',
  },
  voucherInputLabelText: {
    id: 'checkout.cartPage.voucher.inputLabel',
    defaultMessage: 'Enter Voucher Code',
    description: 'Voucher input label',
  },
  voucherInputPlaceHolderText: {
    id: 'checkout.cartPage.voucher.inputPlaceHolder',
    defaultMessage: 'Voucher code',
    description: 'Placeholder text for voucher input',
  },
  voucherCodeInvalidErrorMsgText: {
    id: 'checkout.cartPage.voucher.errorAddInvalidCodeMsg',
    defaultMessage: "The discount code you've entered is invalid.",
    description: 'Voucher add invalid code error msg',
  },
});
